import { combineReducers } from 'redux';

import AssembleiasReducer, { IAssembleiasAssociadoReducer } from './modules/AssembleiasAssociadoReducer';
import AssembleiasAssessorReducer, { IAssembleiasAssessorReducer } from './modules/AssembleiasAssessorReducer'
import LeftMenuReducer, { ILeftMenuReducer } from './modules/LeftMenuReducer';
import AuthReducer, { IAuthReducer } from './modules/AuthReducer';
import ModalsReducer, { IModalsReducer } from './modules/ModalsReducer';
import WSAssembleiasReducer, { IWSAssembleiasReducer } from './modules/WSAssembleiasReducer';

export interface IReducer {
  assembleias: IAssembleiasAssociadoReducer,
  assembleiasAssessor: IAssembleiasAssessorReducer,
  leftMenu: ILeftMenuReducer,
  auth: IAuthReducer,
  modals: IModalsReducer,
  wsAssembleias: IWSAssembleiasReducer,
}

export const getReducer = (): any => {
  return combineReducers({
    assembleias: AssembleiasReducer,
    assembleiasAssessor: AssembleiasAssessorReducer,
    auth: AuthReducer,
    leftMenu: LeftMenuReducer,
    modals: ModalsReducer,
    wsAssembleias: WSAssembleiasReducer
  });
}